// Image assets used across the site
export const ASSETS = {
    logo: "https://customer-assets.emergentagent.com/job_cf371b3d-564f-4648-a955-df636197edde/artifacts/5ugl5hrm_image.png",
    foodCollage: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/qvwbxq2w_image.png",
    drinksCollage: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/iy3u67x7_image.png",
    venueCollage: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/92uebtu4_image.png",
    // Authentic AMOS photos
    waffle: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/87i7b9na_image.png",
    salad: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/aqdzoisc_image.png",
    burger: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/syghzofy_image.png",
    cocktails: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/0wh3xjgm_image.png",
    freddo: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/r0n0eets_image.png",
    // New authentic AMOS gallery
    venueEntrance: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/p1utdq32_%CE%91%CE%BD%CF%84%CE%B9%CC%81%CE%B3%CF%81%CE%B1%CF%86%CE%BF%20%CF%84%CE%BF%CF%85%20FTP_8053.jpg",
    dessertCushion: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/ozgonin9_%CE%91%CE%BD%CF%84%CE%B9%CC%81%CE%B3%CF%81%CE%B1%CF%86%CE%BF%20%CF%84%CE%BF%CF%85%20FTP_8062.jpg",
    steakPlate: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/7t3yrpyc_%CE%91%CE%BD%CF%84%CE%B9%CC%81%CE%B3%CF%81%CE%B1%CF%86%CE%BF%20%CF%84%CE%BF%CF%85%20FTP_8435.jpg",
    miniBurgers: "https://customer-assets.emergentagent.com/job_amos-beach-bar/artifacts/mr8179b9_%CE%91%CE%BD%CF%84%CE%B9%CC%81%CE%B3%CF%81%CE%B1%CF%86%CE%BF%20%CF%84%CE%BF%CF%85%20FTP_8348.jpg",
    // Official AMOS logos (transparent backgrounds)
    logoBlue: "/logos/amos_trans1-1.png",   // light-blue mark on transparent
    logoWhite: "/logos/amos_trans2-1.png",  // white mark on transparent
};

// Constants
export const PHONE = "+30 697 414 1414";
export const PHONE_TEL = "+306974141414";
export const ADDRESS = "Argonafton 8, Mirina 814 00";
export const ADDRESS_FULL = "Argonafton 8, Mirina 814 00, Lemnos, Greece";
export const MAPS_QUERY = "Argonafton+8,+Mirina+81400,+Greece";
export const MAPS_EMBED_URL = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`;
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`;

export const EMAIL = "amosbeachbar@gmail.com";
export const INSTAGRAM_HANDLE = "@amos.lxs";
export const INSTAGRAM_URL = "https://www.instagram.com/amos.lxs/";
export const FACEBOOK_URL = "https://www.facebook.com/p/Amos-Beach-Bar-100092995397963/";

// Country dial codes for the reservation form (priority countries first).
export const COUNTRY_CODES = [
    { code: "+30",  iso: "GR", name: "Greece" },
    { code: "+45",  iso: "DK", name: "Denmark" },
    { code: "+44",  iso: "GB", name: "United Kingdom" },
    { code: "+49",  iso: "DE", name: "Germany" },
    { code: "+33",  iso: "FR", name: "France" },
    { code: "+39",  iso: "IT", name: "Italy" },
    { code: "+34",  iso: "ES", name: "Spain" },
    { code: "+31",  iso: "NL", name: "Netherlands" },
    { code: "+32",  iso: "BE", name: "Belgium" },
    { code: "+41",  iso: "CH", name: "Switzerland" },
    { code: "+43",  iso: "AT", name: "Austria" },
    { code: "+46",  iso: "SE", name: "Sweden" },
    { code: "+47",  iso: "NO", name: "Norway" },
    { code: "+358", iso: "FI", name: "Finland" },
    { code: "+353", iso: "IE", name: "Ireland" },
    { code: "+351", iso: "PT", name: "Portugal" },
    { code: "+357", iso: "CY", name: "Cyprus" },
    { code: "+359", iso: "BG", name: "Bulgaria" },
    { code: "+40",  iso: "RO", name: "Romania" },
    { code: "+48",  iso: "PL", name: "Poland" },
    { code: "+420", iso: "CZ", name: "Czechia" },
    { code: "+36",  iso: "HU", name: "Hungary" },
    { code: "+90",  iso: "TR", name: "Türkiye" },
    { code: "+972", iso: "IL", name: "Israel" },
    { code: "+1",   iso: "US", name: "United States" },
    { code: "+1",   iso: "CA", name: "Canada" },
    { code: "+61",  iso: "AU", name: "Australia" },
    { code: "+971", iso: "AE", name: "UAE" },
    { code: "+966", iso: "SA", name: "Saudi Arabia" },
];
